import React, { useState, useEffect } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    InputAdornment,
    MenuItem,
    Grid,
    InputLabel,
    Input
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import * as logger from '../../../logger';
import { addEmiCss as useStyles } from './VehicleDialogCss';
import { numberWithCommas, replaceCommas, checkNumberOnly } from '../../../utils/utils';
import { fetchCalenderDates, addVehicleEmi, UpdateVehicleEmi } from '../../../store/actions/vehicleActionCreator';
import { connect } from "react-redux";
import AddAlertIcon from '@material-ui/icons/AddAlert';
import AmountInput from '../Inputs/AmountInput';
import { trackDwebEvent } from '../../analytics';


const AddEmiDialog = ({ open, onClose, vehicle, onConfirm, updateEmiSuccess, addEmiSuccess, edit, emiDetails, vehicleIdValue, dispatchAddVehicleEmi, dispatchUpdateVehicleEmi, dispatchFetchCalenderDates }) => {

    let submit;
    const [dialogOpen, setDialogOpen] = useState(open);
    const [calenderDate, setCalenderDate] = useState([]);
    const [dueOnValue, setDueOnValue] = useState(edit && emiDetails && emiDetails.dueDate ? emiDetails.dueDate : "");
    const [reminderValue, setReminderValue] = useState(edit && emiDetails && emiDetails.reminderDate ? emiDetails.reminderDate : "");
    const [reminderToggleValue, setReminderToggleValue] = useState(edit && emiDetails && emiDetails.reminder ? emiDetails.reminder : false);
    const [amount, setAmount] = useState("");

    const initialValues = {
        name: edit && emiDetails && emiDetails.financierName ? emiDetails.financierName : "",
        emi: amount ? amount : edit && emiDetails && emiDetails.emiAmount ? numberWithCommas(emiDetails.emiAmount) : "",
        dueOn: dueOnValue,
        remindMe: reminderValue,
        reminder: reminderToggleValue
    }

    const classes = useStyles();

    let singleTruck = vehicle && vehicle.singleTruck ? vehicle.singleTruck : ""

    useEffect(() => {

        dispatchFetchCalenderDates(
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("EMI Book Dweb", "Get calender dates successfull");
                }
            },
            () => {
                logger.log("EMI Book Dweb", "Get calender dates failed");
            },
        )

    }, [open]);

    useEffect(() => {
        if (vehicle.calenderDates) {
            setCalenderDate(vehicle.calenderDates);
        }
    }, [vehicle.calenderDates])

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Finance Company</div>
                            <TextField
                                placeholder="Enter Name"
                                name="name"
                                variant="outlined"
                                size="small"
                                fieldProps={{
                                    parse: value => value && (value.trim()).length == 0 ? value.trim() : value
                                }}
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Monthly EMI</div>
                            <AmountInput
                                placeholder="Enter EMI"
                                name="emi"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setAmount(e.target.value)}
                                fieldProps={{
                                    // parse: value => value && numberWithCommas(value)
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                }}
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.divSelect}>
                            <div className={classes.title}>Due on</div>
                            {calenderDate && calenderDate.length > 0 &&
                                <>
                                    {/* <InputLabel id="due-on">Due on</InputLabel> */}
                                    <Select
                                        name="dueOn"
                                        variant="outlined"
                                        //label={''}
                                        notched
                                        // labelWidth={0}
                                        // placeholder='Due on'
                                        formControlProps={{ margin: 'none', size: "small", fullWidth: false, labelWidth: 0 }}
                                        className={classes.selectV1}
                                        onClick={(e) => handleDueOn(e.target.value)}
                                        // id="due-on"
                                        // labelId="due-on"
                                        fieldProps={{
                                            endAdornment: <InputAdornment position="end">of every month</InputAdornment>
                                        }}
                                    >
                                        {calenderDate && calenderDate.length > 0 && calenderDate.map((cal) => (
                                            <MenuItem key={cal.emi_due_display} value={cal.emi_due_display}>{cal.emi_due_display}</MenuItem>
                                        ))}
                                    </Select>
                                </>
                            }
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: values.dueOn,
                field: (
                    <>
                        <div className={classes.divV7}>
                            <div className={classes.divV8}>
                                <AddAlertIcon />
                                <div>&nbsp;Remind me on</div>
                                {calenderDate && calenderDate.length > 0 &&
                                    <Select
                                        name="remindMe"
                                        variant="outlined"
                                        //label={''}
                                        notched
                                        labelWidth={0}
                                        placeholder={'Due on'}
                                        formControlProps={{ margin: 'none', size: "small", fullWidth: false, labelWidth: 0 }}
                                        className={classes.selectV2}
                                    >
                                        {calenderDate && calenderDate.length > 0 && calenderDate.map((cal) => (
                                            (cal.hide_in_reminder_date_list == false &&
                                                <MenuItem key={cal.emi_due_display} value={cal.emi_due_display}>{cal.emi_due_display}</MenuItem>
                                            )))}
                                    </Select>
                                }
                                <div >every month</div>
                            </div>
                            <Switches
                                size='small'
                                margin='normal'
                                formControlProps={{
                                    className: classes.switchControl
                                }}
                                onChange={(e, value) => { setReminderToggleValue(value) }}
                                className={classes.switch}
                                name="reminder"
                                data={{ label: '', value: true }} label="" />
                        </div>
                    </>
                )
            }
        ]
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onSubmit = values => {


        var data = {
            financierName: values.name ? (values.name).trim() : "",
            emiAmount: replaceCommas(values.emi),
            dueDate: values.dueOn,
            isReminderEnabled: values.reminder,
            reminderDate: values.remindMe
        };

        if (edit) {

            dispatchUpdateVehicleEmi(
                vehicleIdValue,
                emiDetails.id,
                data,
                (data) => {
                    if (data.status && data.status.code) {
                        updateEmiSuccess();
                        logger.log("EMI Book Dweb", "Update EMI successfull");
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                () => {
                    logger.log("EMI Book Dweb", "Update EMI failed");
                }
            );

        }
        else {
            dispatchAddVehicleEmi(vehicleIdValue,
                data,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        addEmiSuccess();
                        logger.log("EMI Book Dweb", "Add emi successfull");
                        setDialogOpen(false);
                        onConfirm();
                    } else {
                        trackDwebEvent("Dweb SVP EMI Create Failed", {
                            vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
                            vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
                            emi_amount: values && values.emi ? values.emi : "",
                            emi_reminder_date: values && values.remindMe ? values.remindMe : "",
                            emi_due_date: values && values.dueOn ? values.dueOn : "",
                            emi_financer: values && values.name ? (values.name).trim() : "",
                            error_reason: data && data.status && data.status.message ? data.status.message : ""
                        });
                    }
                },
                () => {
                    logger.log("EMI Book Dweb", "Add emi failed");
                }
            );
        }

    }

    const validate = values => {

        const errors = {}

        let financeName = values.name ? /^[A-Za-z]+$/.test(values.name.replace(/\s+/g, '')) : "";

        if (!financeName) {
            errors.name = "Please enter Finance Company Name."
        }

        if (!values.emi || !checkNumberOnly(replaceCommas(values.emi))) {
            errors.emi = "Please enter valid amount."
        }

        if (!values.dueOn) {
            errors.dueOn = "Please select due on."
        }

        return errors;


    }

    const handleDueOn = (value) => {
        setDueOnValue(value);
        var index = calenderDate.findIndex(x => x.emi_due_display === value);
        var reminderValue = calenderDate && calenderDate[index] && calenderDate[index].emi_reminder_display ? calenderDate[index].emi_reminder_display : "";
        setReminderValue(reminderValue);
        setReminderToggleValue(true);
    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='sm'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper2, paperWidthSm: classes.paperWidth }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV1}>Add EMI</div>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <Divider className={classes.marginV3} />
                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button className={classes.confirmV1} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )

}

const mapStateToProps = (state) => ({ vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchFetchCalenderDates: (onSuccess, onFailure) => dispatch(fetchCalenderDates(onSuccess, onFailure)),
    dispatchAddVehicleEmi: (vehicleId, data, onSuccess, onFailure) => dispatch(addVehicleEmi(vehicleId, data, onSuccess, onFailure)),
    dispatchUpdateVehicleEmi: (vehicleId, emiId, data, onSuccess, onFailure) => dispatch(UpdateVehicleEmi(vehicleId, emiId, data, onSuccess, onFailure)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddEmiDialog);